import React from 'react';
import '../styles/products.css';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";


export default function Products() {
  const products = [
    { img: "/bk9.jpg", title: "Premium Red Brick" },
    { img: "/new4.jpg", title: "Fly Ash Brick" },
    { img: "/new7.jpg", title: "Solid Clay Brick" },
    { img: "/new5.jpg", title: "High-Density Brick" },
    { img: "/ss6.png", title: "Construction Grade Brick" },
    { img: "/ss5.png", title: "Heavy Duty Brick" },
    { img: "/tpa3.jpg", title: "Eco Clay Brick" },
    { img: "/new1.jpg", title: "TPA Signature Brick" },
  ];

  return (
    <div className="products-page">

      {/* HEADER / HERO SECTION */}
      <div className="products-hero">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our Products
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Explore our range of strong, durable and high-quality bricks designed
          for every type of construction project — built with precision and consistency.
        </motion.p>
      </div>

      {/* PRODUCT GRID */}
      <div className="products-grid-new">
        {products.map((p, i) => (
          <motion.div
            key={i}
            className="product-card-new"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            <div className="product-image-new">
              <img src={p.img} alt={p.title} />
            </div>
            {/* <div className="product-info">
              <h3>{p.title}</h3>
              <Link to="/contact" className="order-now-btn">
                Order Now
              </Link>
            </div> */}
          </motion.div>
        ))}
      </div>

      {/* CTA */}
      <div className="product-cta-section">
        <Link to="/contact">
          <button className="quote-btn-final">Get a Quote</button>
        </Link>
      </div>
    </div>
  );
}
